import React from 'react';
import { URL } from '../variables';
import { getLanguageTexts, getSelectedLanguage, languageOptions, setSelectedLanguage } from '../language';
import { CandidateLoader } from '../Home/CandidateUi';

class SelectFaculdade extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      faculdades: [],
      faculdade_select: 'tete',
      loading: false,
      msgErro: '',
      redirect: false,
      selectedLanguage: getSelectedLanguage()
    }
    this.handleLanguageChange = this.handleLanguageChange.bind(this);
    this.handleLanguageEvent = this.handleLanguageEvent.bind(this);
  }

  handleLanguageChange(event) {
    this.setState({ selectedLanguage: setSelectedLanguage(event.target.value) });
  }

  handleLanguageEvent(event) {
    this.setState({ selectedLanguage: event.detail || getSelectedLanguage() });
  }

  change_faculdade(event) {
    this.setState({ faculdade_select: event.target.value });

  }

  // renderRedirect = () => {
  //   if (this.state.redirect) {
  //     return <Redirect to={'/'+this.state.faculdade_select.slug} />
  //   }
  // }

  get_faculdades() {
    fetch(`${URL}api/get_faculdades`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',

        // 'Authorization': `Bearer ${this.props.token}`,
        // 'Content-Type': 'application/json',
      }
    }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();
        console.log(resp);
        if (resp.errors != null || resp.error != null) {
          let errors = Object.values(resp.errors);
          let erro = '';
          for (let i = 0; i < errors.length; i++) {
            if (i != errors.length - 1)
              erro += errors[i] + '\n';
            else
              erro += errors[i];
          }
          console.log(erro);

          this.setState({ loading: false, msgErro: erro, refresh: false, loadingMore: false });
        }
        else {
          let selected = '';
          if (resp.faculdades.length > 0) {

            selected = resp.faculdades[0].slug;
          }
          this.setState({ faculdades: resp.faculdades, loading: false, msgErro: '', faculdade_select: selected });
          // this.setState({ loading: false, refresh: false, loadingMore: false, msgErro: '' });

        }




      } catch (err) {
        console.log(err);
        this.setState({ loading: false, msgErro: getLanguageTexts(this.state.selectedLanguage).server_response_error, refresh: false, loadingMore: false });

      }

    })
      .catch((err) => {
        console.log(err);
        this.setState({ loading: false, msgErro: getLanguageTexts(this.state.selectedLanguage).internet_connection_error, refresh: false, loadingMore: false });
      });
  }

  componentDidMount() {
    localStorage.setItem('external_camera_theme', 'light');
    document.body.classList.remove('external-camera-dark-theme');
    window.addEventListener('external_camera_language_change', this.handleLanguageEvent);
    this.setState({ loading: true, msgErro: '' });
    this.get_faculdades();
  }

  componentWillUnmount() {
    window.removeEventListener('external_camera_language_change', this.handleLanguageEvent);
  }






  render() {
    console.log(this.state.faculdade_select)
    const t = getLanguageTexts(this.state.selectedLanguage);
    return (
      <div className="candidate-select-page">
        {this.state.loading && <div className="candidate-auth-loading">
          <CandidateLoader title={t.loading_data} description={t.external_camera_loading_hint} />
        </div>}
        {this.state.loading==false && <div id="app" className="candidate-select-shell external-camera-select-shell">
          <header className="candidate-select-header" style={{ justifyContent: 'space-between' }}>
            <img src={require('../assets/images/logo-ontest.png')} alt="OnTest" />
            <ul className="navbar-right d-flex list-inline float-right mb-0">
              <li className="candidate-header-language external-camera-header-language">
                <i className="mdi mdi-web"></i>
                <select value={this.state.selectedLanguage} onChange={this.handleLanguageChange.bind(this)} aria-label={t.language_label}>
                  {languageOptions.map((item) => (
                    <option key={item.value} value={item.value}>{item.value}</option>
                  ))}
                </select>
              </li>
            </ul>
          </header>

          <main className="candidate-select-main">
            <section className="candidate-select-card">
              <div className="candidate-select-copy">
                <span className="candidate-auth-kicker">{t.external_camera_access}</span>
                <h1>{t.choose_institution}</h1>
                <p>{t.choose_institution_hint}</p>
              </div>

              <div className="candidate-select-list">
                          {this.state.faculdades.map((item,id)=>(
                            <a key={id} href={'/' + item.slug + '/login'} className="candidate-select-item">
                              <div className="candidate-select-logo">
                              <img src={item.logo}
                                         alt={item.name} />
                              </div>
                            <div className="candidate-select-info"><strong>{item.name}</strong><span>{t.access_external_camera}</span></div>
                            <span className="candidate-select-action" aria-hidden="true"><i className="mdi mdi-arrow-right"></i></span>
                            </a>
                          ))}
                          {/* {{ Form::select('select_faculdade',$faculdades,null, ['autocomplete' => 'off','required' => true,'data-error' => 'Este campo é obrigatório.','class'=>'custom-select','id'=>'faculdade']) }} */}
                          {/* <select value={this.state.faculdade_select} className="form-control" id="cameras" onChange={this.change_faculdade.bind(this)}>
                            {this.state.faculdades.map((item, id) => (
                              <option key={id} value={item.slug}>{item.name}</option>
                            ))}
                          </select> */}
              </div>
              {this.state.faculdades.length == 0 && <div className="candidate-select-empty">
                <i className="mdi mdi-school-outline"></i>
                <strong>{t.no_institution_available}</strong>
                <span>{t.try_again_later}</span>
              </div>}
            </section>
          </main>
        </div>}
      </div>
    );
  }


}

export default SelectFaculdade;
